import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, OutlinedInput, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxButtons, sxCloseIconButton, sxModal, sxInput, sxLabel, sxError } from './sxProps';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import { cellphoneMask } from '../../../../../utils/PhoneRegex';
import { useFormik } from 'formik';
import { ScheduleContactsValidation } from '../../../../../interfaces/validation/ScheduleContactsValidation';
import DefaultText from '../../../../../components/Accessibility/DefaultText';

interface UserData { 
  cel: string, 
  tel: string, 
  email: string 
}

interface Props {
    showModal: boolean;
    handleCancelarClick: () => void;
    handleSalvarClick: (data: UserData) => void;
    userData: UserData;
}

const ContatoModal: React.FC<Props> = ({
  showModal, handleCancelarClick, handleSalvarClick, userData
}) => {

  const accessibility = useAccessibility();
  const { fontSizeStyleAccessibility } = useAccessibility();

  const [tel, setTel] = useState<string>('');
  const [cel, setCel] = useState<string>('');
  const [email, setEmail] = useState<string>('');

  const formik = useFormik({
    initialValues: { tel, cel, email },
    validationSchema: ScheduleContactsValidation,
    onSubmit: (values) => {
      handleSalvarClick({ tel: values.tel, cel: values.cel, email: values.email });
    },
    validateOnChange: false
  });

  useEffect(() => {
    setTel(userData.tel)
    setCel(userData.cel)
    setEmail(userData.email)
  }, [userData])

  return (
    <div>
      <Modal
        open={showModal}
      >
        <Box sx={sxModal} style={{...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility}}>
          <form onSubmit={formik.handleSubmit}>
          <IconButton
            aria-label="fechar"
            onClick={handleCancelarClick}
            sx={sxCloseIconButton}
            >
              <FontAwesomeIcon icon={faTimes} size="1x" color='black' style={accessibility.textStyleAccessibility} />
            </IconButton>
            <DefaultText sx={{color: '#383838', fontFamily: 'UnimedSans-Bold', fontSize: '20px'}} component="h1" marginBottom="15px" text="Atualizar dados do contato" />
            <div className="flex-col gap-20" style={{marginBottom: '30px'}}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <Typography component='label' htmlFor='telefone' style={accessibility.textStyleAccessibility} sx={sxLabel}>Telefone</Typography>
                <OutlinedInput
                  fullWidth
                  type={"tel"}
                  value={formik.values.tel}
                  onChange={(e) => formik.setFieldValue('tel', cellphoneMask(e.target.value))}
                  name="tel"
                  error={!!formik.errors.tel}
                  maxRows={1}
                  inputProps={{ maxLength: 15 }}
                  sx={sxInput}
                  style={fontSizeStyleAccessibility}
                />
                {formik.errors.tel && (
                  <Typography
                    sx={sxError}
                    style={fontSizeStyleAccessibility}
                    tabIndex={0}
                  >
                    {formik.errors.tel}
                  </Typography>
                )}
              </div>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <Typography component='label' htmlFor='celular' style={accessibility.textStyleAccessibility} sx={sxLabel}>Celular</Typography>
                <OutlinedInput
                  fullWidth
                  type={"tel"}
                  value={formik.values.cel}
                  onChange={(e) => formik.setFieldValue('cel', cellphoneMask(e.target.value))}
                  name="cel"
                  error={!!formik.errors.cel}
                  maxRows={1}
                  inputProps={{ maxLength: 15 }}
                  sx={sxInput}
                  style={fontSizeStyleAccessibility}
                />
                {formik.errors.cel && (
                  <Typography
                    style={fontSizeStyleAccessibility}
                    tabIndex={0}
                    sx={sxError}
                  >
                    {formik.errors.cel}
                  </Typography>
                )}
              </div>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <Typography component='label' htmlFor='email' style={accessibility.textStyleAccessibility} sx={sxLabel}>E-mail</Typography>
               <OutlinedInput
                  fullWidth
                  type={"email"}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  name="email"
                  error={!!formik.errors.email}
                  maxRows={1}
                  inputProps={{ maxLength: 30 }}
                  sx={sxInput}
                  style={fontSizeStyleAccessibility}
                />
                {formik.errors.email && (
                  <Typography
                    style={fontSizeStyleAccessibility}
                    tabIndex={0}
                    sx={sxError}
                  >
                    {formik.errors.email}
                  </Typography>
                )}
              </div>
            </div>
            
            <Box sx={sxButtons}>
              <DefaultButton text="Cancelar" variant="outlined" onClick={handleCancelarClick} />
              <DefaultButton text="Salvar" type="submit" />
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default ContatoModal;
